<template>
  <div class="bgtable" v-show="showLables">
    <div class="labels-box">
      <a href="javascript:;" class="bgligin-close"  @click="lBoxShowChange(false)">
        <img src="../assets/img/icon-close.png">
      </a>
      <h3>选择兴趣标签</h3>
      <p>可以选择5~8个，已选择{{labelIds.length}}个</p>
      <div class="clearfix tag-box"  v-loading="loading">
        <div v-for="(arr, index) in list" :key="index" class="tag-box-line clearfix">
          <span v-for="item in arr" :key="item.id" @click="lableClick(item)" :class="['tag-item', {'checked': item.checked}]"> {{ item.label }} </span>
        </div>
      </div>
      <div class="refresh-btn" @click="refreshClick">
        <img src="../assets/img/icon_refresh.png" alt="">
        <span>换一换</span>
      </div>
      <div class="next-btn" @click="next">下一步</div>
    </div>
  </div>
</template>

<script>
  import { ApiGetMyLabel, ApiGetLabel, ApiSelectedLabel } from '../net/course/index.js'
  export default {
    data () {
      return {
        pageNum: 1,
        pageSize: 24,
        tagList: [],
        labelIds: [], // 选中的标签
        loading: false
      }
    },
    computed: {
      list () {
        let _arr = []
        const _list = []
        this.tagList.forEach((item, index) => {
          const _lable = { ...item, checked: false }
          _lable.checked = this.labelIds.includes(item.id)
          _arr.push(_lable)
          if ((index + 1) % 3 === 0 || (index + 1) === this.tagList.length) {
            _list.push(_arr)
            _arr = []
          }
        })
        // console.log(_list)
        return _list
      },
      showLables: function () {
        return this.$store.state.showLabels
      }
    },
    watch: {
      showLables (newVal, oldVal) {
        if (newVal) {
          this.getLabel()
          this.getgory()
        }
      }
    },
    methods: {
      lBoxShowChange () {
        this.$store.commit('changeShowLabels', false)
      },
      getgory(){
        const pramas = {
          pageNum: 1,
          pageSize: 999
        }
        ApiGetMyLabel(pramas).then(res=>{
          // console.log('res',res)
          if(res.code == 200){
            const _labels = res.value || []
            this.labelIds = _labels.map(item=>{
              return item.id
            })
          }
        })
      },
      getLabel () {
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
        this.loading = true
        ApiGetLabel(params).then(res => {
          // console.log(res)
          if (res.code === 200) {
            if (res.value.length === 0) {
              this.pageNum = 1
              this.getLabel()
            } else {
              this.tagList = res.value
            }
          }
          this.loading = false
        })
      },
      lableClick (lable) {
        if (!lable.checked) {
          if (this.labelIds.length === 8) {
            this.$message(`最多可选择8个兴趣标签`)
          } else {
            this.labelIds.push(lable.id)
          }
        } else {
          this.labelIds = this.labelIds.filter(item => {
            return item !== lable.id
          })
        }
      },
      refreshClick () {
        if (this.pageNum == 1 && this.tagList.length < this.pageSize) {
          this.$message('没有更多标签了')
          return
        }
        this.pageNum += 1
        this.getLabel()
      },
      next () {
        if (this.labelIds.length < 5) {
          this.$message(`最少请选择5个兴趣标签`)
          return
        }
        const pramas = {labelIds: this.labelIds}
        ApiSelectedLabel(pramas).then(res=>{
          // console.log(res)
          if (res.code == 200) {
            this.$router.push('/MyFind')
            this.$store.commit('changeShowLabels', false)
            this.$store.commit('changeRefreshLabels', false)
          }
        })
      }
    },
    mounted () {
      if (this.$store.state.isLogin) {
        this.getLabel()
        this.getgory()
      }
    }
 }
</script>

<style scoped>
.labels-box{
  width: 500px;
  height: 660px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -330px;
  margin-left: -250px;
  background: #fff;
  border-radius: 8px;
}
.labels-box>h3{
  height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #111111;
  line-height: 25px;
  text-align: center;
  margin: 25px 0 9px;
}
.labels-box>p{
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #999999;
  line-height: 17px;
  text-align: center;
  margin-bottom: 32px;
}
.tag-box {
  width: calc(100% - 100px);
  margin: 0 auto;
  min-height: 300px;
}
.tag-box .tag-box-line {
  width: 100%;
}
.tag-item {
  float: left;
  border-radius: 16px;
  border: 1px solid #D8D8D8;
  padding: 6px 12px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #454545;
  line-height: 20px;
  margin-bottom: 12px;
  margin-right: 12px;
  cursor: pointer;
}
.tag-item:nth-child(3) {
  margin-right: 0;
}
.tag-item.checked {
  color: #fff;
  background-color: #0BB34A;
  border-color: #0BB34A;
}
.refresh-btn {
  width: 280px;
  margin: 26px auto 12px;
  height: 44px;
  border-radius: 24px;
  border: 1px solid #D8D8D8;
  text-align: center;
  cursor: pointer;
}
.refresh-btn img{
  width: 20px;
  height: 20px;
  margin: 12px 6px 0 106px;
  float: left;
}
.refresh-btn span {
  float: left;
  line-height: 44px;
}
.next-btn {
  width: 280px;
  height: 44px;
  margin: 0 auto;
  line-height: 44px;
  background: #37BB54;
  border-radius: 24px;
  text-align: center;
  color: #fff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/common/lables.vue